import Vimeo from '@u-wave/react-vimeo'
import React, { useEffect, useState } from 'react'
import { FadeLoader } from 'react-spinners'
import Button from '../../../../components/button'
import { Link, useNavigate } from 'react-router-dom'
import TickMark from '../../../../components/tickmark'
import { saveStepsProgress, verifyZoom } from '../../../../services/medium'
import { useDispatch, useSelector } from 'react-redux'
import { getZoomAuthUrl } from '../../../../services/uidata'
import { setLoading } from '../../../../reducer/auth/auth'

export default function StepOne({ NextStep,innerWidthHandler }) {
    const { id } = useSelector((state) => state.user.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showLoader, setShowLoader] = useState(true);
    const [verificationStatus, setVerificationStatus] = useState(0);
    const [verifyText, setVerifyText] = useState('');
    const [showZoomModal, setShowZoomModal] = useState(false);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [confirmedOnce, setConfirmedOnce] = useState(() => {
      try {
        return !!localStorage.getItem('zoom_terms_accepted');
      } catch (e) {
        return false;
      }
    });

    const openAppointMent = () => {
        window.open("/integration", "_blank", "noreferrer")
    }
    function getPathFromUrl(url) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("status");
        newUrl.searchParams.delete("message");
        window.history.replaceState({}, document.title, newUrl.href);
    }
    useEffect(() => {
        getPathFromUrl();
        setTimeout(() => {
            verifyZoomHandler()

        }, 5000)
    }, [])

    const verifyZoomHandler = () => {
        let body = {
            medium_id: id
        }
        verifyZoom(body).then((data) => {
            console.log(data)
            if (data.data.status) {
                setVerifyText(data.data.message)
                setVerificationStatus(1);
                setShowLoader(false);
            }
            else {
              setVerifyText(data.data.message)
              // show confirmation popup first; only if not already confirmed
              if (!confirmedOnce){
                 setShowConfirmPopup(true);
              }else{
                 getAuthUrlNew();
              }
              setShowLoader(false);
            }


        })
    }
   const checkZoomInstalled = (onSuccess, onFail) => {
  let appOpened = false;

  const handleBlur = () => {
    appOpened = true;
  };

  window.addEventListener("blur", handleBlur);

  // Try opening Zoom app
  window.location.href = "zoommtg://zoom.us";

  setTimeout(() => {
    window.removeEventListener("blur", handleBlur);

    if (appOpened) {
      onSuccess(); // ✅ Zoom installed
    } else {
      onFail(); // ❌ Not installed
    }
  }, 2000);
};
const getAuthUrlNew = () => {
  checkZoomInstalled(
    () => {
      // ✅ Zoom installed → call API
    //   dispatch(setLoading(true));
 setVerificationStatus(2);
    //   getZoomAuthUrl("onboarding")
    //     .then((data) => {
    //       dispatch(setLoading(false));

    //       if (data.data.status) {
    //         window.location.href = data.data.data.redirect_url;
    //       }
    //     })
    //     .catch((err) => {
    //       dispatch(setLoading(false));
    //       console.log(err);
    //     });
    },
    () => {
      // ❌ Zoom not installed → show message
    //   alert(
    //     "We couldn’t open the Zoom link because the Zoom app isn’t installed. Please download Zoom and try again."
    //   );
    setShowZoomModal(true);
    }
  );
};
    const getAuthUrl = () => {
        
        dispatch(setLoading(true));
        getZoomAuthUrl("onboarding")
            .then((data) => {
                dispatch(setLoading(false));
                if (data.data.status) {
                    // console.log(data.data.data.redirect_url)   ;
                    // return;
                    window.open(data.data.data.redirect_url, "_self");
                }
            })
            .catch((err) => {
                dispatch(setLoading(false));
                console.log(err);
            });
    };

    // Auto-open confirmation popup when verification indicates Zoom needs linking
    useEffect(() => {
      if (verificationStatus === 2 && !confirmedOnce) {
        setShowConfirmPopup(true);
      }
    }, [verificationStatus]);

    // Prevent closing the confirmation popup via Escape key
    useEffect(() => {
      const onKeyDown = (e) => {
        if (showConfirmPopup && (e.key === 'Escape' || e.keyCode === 27)) {
          e.preventDefault();
          e.stopPropagation();
        }
      };
      if (showConfirmPopup) {
        document.addEventListener('keydown', onKeyDown, true);
      }
      return () => document.removeEventListener('keydown', onKeyDown, true);
    }, [showConfirmPopup]);

    const savestep = () => {
        let body = {
            step_number: 1
        }
        saveStepsProgress(body).then((data) => {
            if (data.data.status) {
                NextStep()
                localStorage.setItem('step',1)
            }
        }).catch(() => {

        })
    }
    return (
        <>
        <div className="onboarding-step-content">

            <div className='onboarding-step-header text-left'>

                <span className="onboarding-step-badge">Step 1</span>
                <div>
                    <h3 className='font-size-40'>Connect Your Zoom</h3>
                    <ol className='font-size-18 line-height-24px'>
                        <li>Watch the video below.</li>
                        <li>Connect your Zoom account.</li>
                    </ol>
                    <ol className='font-size-18 line-height-24px red'>
                        <li>Note: Be sure to download the Zoom app on every device you’ll use for VerySoul sessions, and log into your Zoom account when hosting.</li>
                    
                    </ol>
                </div>
                {/* <p className='font-size-18 line-height-24px'></p> */}


            </div>
            <div className="onboarding-media-card">
                <div className="onboarding-media-header">
                    <h5>Watch walkthrough</h5>
                </div>
                <div className="onboarding-media-body">
                    <div className="onboarding-video-wrap ratio ratio-16x9">
                        <Vimeo
                            muted={true}
                            autoplay={false}
                            // className="popover-video"
                            width={innerWidthHandler()}
                            height={330}
                            video={"https://vimeo.com/922691222/31abba4ecc"}
                        />
                    </div>
                </div>
            </div>
            {showLoader && <div className='onboarding-status-card status-loading'>
                <span className="onboarding-status-icon">
                    <FadeLoader size={8} color='#d5a67b' />
                </span>
                <div className="onboarding-status-copy">
                    <h6>Checking Zoom connection</h6>
                    <p>Please wait while we are verifying your Zoom.</p>
                </div>
            </div>}
            {verificationStatus === 1 &&
                <div className='onboarding-status-card status-success'>
                    <span className="onboarding-status-icon">
                        <img className='w-20-px' src="./images/tick-marks.png" alt="Success" />
                    </span>
                    <div className="onboarding-status-copy">
                        <h6>Zoom connected</h6>
                        <p className='margin-unset'>{verifyText}</p>
                    </div>
                </div>
            }
            {verificationStatus === 2 &&
                <div className='onboarding-status-card status-warning'>
                    <span className="onboarding-status-icon">
                        <img className='w-20-px' src="./images/error-mark.png" alt="Warning" />
                    </span>
                    <div className="onboarding-status-copy">
                        <h6>Zoom needs attention</h6>
                        <p className='margin-unset'>{'Please connect your Zoom below'}</p>
                    </div>
                </div>
            }
            {!showLoader && <div className='onboarding-actions'>

                {verificationStatus === 1 && <Button
                    className={"  margin-unset action-button"}
                    status={0}
                    onClick={() => savestep()}
                    title="Next" />}

                {verificationStatus === 2 && <Button
                    className={"action-button margin-unset"}
                    status={0}
                   onClick={getAuthUrl}
                    title="Link your Zoom" />}

                {/* <Link to={'/'} > Lear more</Link> */}
            </div>}
           


        </div>
   {showZoomModal && (
  <>
    {/* Backdrop must be a sibling to the modal */}
    <div 
      className="modal-backdrop fade show" 
      style={{ zIndex: 1040 }}
    ></div>

    <div 
      className="modal fade show" 
      style={{ display: "block", zIndex: 1050 }} 
      onClick={() => setShowZoomModal(false)} // Close on background click
    >
      <div 
        className="modal-dialog modal-dialog-centered" 
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        <div className="modal-content shadow-lg border-0">
          
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold">Zoom Not Installed</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShowZoomModal(false)}
            ></button>
          </div>

          <div className="modal-body py-4">
            <p className="text-center mb-0">
              We couldn’t open the Zoom link because the Zoom app isn’t installed.
              Please download Zoom and try again.
            </p>
          </div>

          {/* This section puts the buttons together side-by-side */}
          <div className="modal-footer border-0 pt-0 d-flex justify-content-center gap-2">
            <a
              href="https://zoom.us/download"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary px-4 py-2"
              style={{ backgroundColor: '#d5a67b', border: 'none', borderRadius: '4px' }}
            >
              Download Zoom
            </a>

            <button
              className="btn btn-dark px-4 py-2"
              style={{ backgroundColor: '#3d4146', border: 'currentcolor', borderRadius: '4px', color: 'black',background : "transparent", borderColor : "#d5a67b", borderStyle : "solid" }}
              onClick={() => setShowZoomModal(false)}
            >
              Close
            </button>
          </div>

        </div>
      </div>
    </div>
  </>
)}
{/* Confirmation popup (Bootstrap) */}
{showConfirmPopup && (
  <>
    <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>

    <div className="modal fade show" style={{ display: "block", zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '720px', width: 'calc(100% - 2rem)' }}>
        <div className="modal-content rounded-4 shadow-lg border-0 overflow-hidden" style={{ width: '100%' }}>
          {/* <div className="modal-header bg-light border-0 justify-content-center py-4">
            <div className="text-center w-100">
              <h5 className="modal-title fw-bold mb-1" style={{ fontSize: '1.35rem' }}>Onboarding Confirmation</h5>
          
            </div>
          </div> */}

          <div className="modal-body px-5 py-4">
            <div className="border rounded-3 px-3 py-3 mb-4" style={{ backgroundColor: '#f8f9fa', borderColor: '#d1d5db' }}>
              <p className="mb-3 fw-bold" style={{ fontSize: '1.05rem', lineHeight: '1.5', color: '#111827' }}>
                Before continuing, you&apos;ll be prompted to open a Zoom meeting.
              </p>
              <p className="mb-3 text-left" style={{ fontSize: '1rem', lineHeight: '1.6', color: '#4b5563' }}>
                This step helps us check whether the Zoom app is installed on your device.
              </p>
              <p className="mb-3 text-left" style={{ fontSize: '1rem', lineHeight: '1.6', color: '#4b5563' }}>
                If Zoom is not installed, we strongly recommend installing it now, as it will make joining and managing your sessions much easier.
              </p>
              <p className="mb-0 text-left" style={{ fontSize: '1rem', lineHeight: '1.6', color: '#4b5563' }}>
                After Zoom opens, please return to this page to continue your onboarding process.
              </p>
            </div>

            <div className="form-check py-3 border rounded-3 px-3" style={{ backgroundColor: '#f8f9fa' }}>
              <input
                className="form-check-input mt-1"
                type="checkbox"
                id="termsCheck"
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
              />
              <label className="form-check-label ms-3" htmlFor="termsCheck" style={{ fontSize: '1rem' }}>
                I am ready to continue and open Zoom.
              </label>
            </div>
          </div>

          <div className="modal-footer border-0 py-4 justify-content-center">
            <button
              type="button"
              className={`btn btn-lg w-100 ${termsAccepted ? 'btn-primary-site' : 'btn-secondary'}`}
              disabled={!termsAccepted}
              style={!termsAccepted ? { opacity: 0.65, pointerEvents: 'none' } : {}}
              onClick={() => {
                  setShowConfirmPopup(false);
                  setTermsAccepted(false);
                  try {
                    localStorage.setItem('zoom_terms_accepted', '1');
                  } catch (e) {}
                  setConfirmedOnce(true);
                  // After user confirms, attempt to open/link Zoom
                  getAuthUrlNew();
                }}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </>
)}
        </>
    )
}
